import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactElement } from "react";
import { Tooltip } from "react-tooltip";
interface DropVoteProgressingProps {
  readonly current: number | null | undefined;
  readonly projected: number | null | undefined;
  readonly subtle?: boolean | undefined;
}
export default function DropVoteProgressing(t0) {
  const $ = _c(20);
  const {
    current,
    projected,
    subtle: t1
  } = t0;
  const subtle = t1 === undefined ? false : t1;
  if (typeof current !== "number" || typeof projected !== "number") {
    return null;
  }
  const isProgressing = current !== projected;
  if (!isProgressing) {
    return null;
  }
  const isPositiveProgressing = current < projected;
  let color;
  if (subtle) {
    color = isPositiveProgressing ? "tw-text-iron-400 tw-font-mono" : "tw-text-iron-600 tw-font-mono";
  } else {
    color = isPositiveProgressing ? "tw-text-emerald-500 tw-bg-emerald-500/10 tw-px-2 tw-py-0.5 tw-rounded tw-border tw-border-solid tw-border-emerald-500/20 tw-font-mono" : "tw-text-rose-500 tw-bg-rose-500/10 tw-px-2 tw-py-0.5 tw-rounded tw-border tw-border-solid tw-border-rose-500/20 tw-font-mono";
  }
  const t2 = `tw-flex tw-items-center tw-gap-2 ${subtle ? "" : "tw-ml-0.5"}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      animationDuration: "2s"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = `drop-vote-progress-${current}-${projected}`;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FontAwesomeIcon icon={faArrowRight} className="tw-flex-shrink-0 tw-size-2.5 tw-text-iron-600" />;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = `tw-text-sm tw-font-medium tw-tracking-tight ${color}`;
  let t7;
  if ($[2] !== projected) {
    t7 = formatNumberWithCommas(projected);
    $[2] = projected;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t6 || $[5] !== t7) {
    t8 = <span className={t6}>{t7}</span>;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t2 || $[8] !== t4 || $[9] !== t8) {
    t9 = <span className={t2} style={t3} data-tooltip-id={t4}>{t5}{t8}</span>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = `drop-vote-progress-${current}-${projected}`;
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    };
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== projected) {
    t12 = formatNumberWithCommas(projected);
    $[12] = projected;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t10 || $[15] !== t12) {
    t13 = <Tooltip id={t10} place="top" offset={8} opacity={1} style={t11}>Projected vote count at decision time:{" "}{t12}</Tooltip>;
    $[14] = t10;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13 || $[18] !== t9) {
    t14 = <>{t9}{t13}</>;
    $[17] = t13;
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  return t14;
}